import { GenericAbortSignal } from 'axios';

import { DenialList } from 'models/DenialList';
import { Paginated } from 'models/Paginated';
import { BaseIndexQueryParams } from 'services/api/types';
import http from 'services/http';

export type AdminDenialListsIndexParams = BaseIndexQueryParams & {
  clientId?: string;
};

export const adminDenialListsQueryKeys = {
  index: (params: Record<string, any> = {}) => ['adminDenialLists', 'index', params],
};

export async function indexAdminDenialLists(params: AdminDenialListsIndexParams, signal?: GenericAbortSignal) {
  return http.get<Paginated<DenialList>>('/admin/denial_lists', { params, signal }).then((response) => response.data);
}
